import * as yup from 'yup';

export const ThankYouSchema = yup.object().shape({
  bodyMessage: yup
    .string()
    .required({ tx: 'errors.required' })
    .max(255, 'Message should be less than 256 characters.'),
});
